import { MenuItem } from 'side/MenuItem'
import Typography from '@material-ui/core/Typography'
import TocIcon from '@material-ui/icons/Toc'
import AddAlarmIcon from '@material-ui/icons/AddAlarm'
import { CloseIcon } from 'icons'
import { strings } from 'strings'
import { useHistory } from 'react-router-dom'

const RinexMenu = () => {
  const { push } = useHistory()

  return (
    <>
      <MenuItem route="/panel" icon={CloseIcon} onClick={() => push('/')} />
      <Typography style={{ fontSize: 14, color: '#fff', flexGrow: 1 }}>
        {strings.rinexService}
      </Typography>
      <MenuItem route="/rinex/new" icon={AddAlarmIcon} />
      <MenuItem route="/rinex/list" icon={TocIcon} />
    </>
  )
}

export default RinexMenu
